import { createFeatureSelector } from "redux/utility"

export const reducerName = "core" as const

export const createCoreFeatureSelector = (featureName: string): unknown =>
    createFeatureSelector(`${reducerName}.${featureName}`)
